import {UserServiceClient} from '@multipass-user-service';

import {ReasonError} from '../reasonError';

export interface UpdatedScriptPreference {
    readonly scriptPreference: string | null;
    readonly pendingDecision: string | null;
}

export interface AccountService {
    deleteAccount(userId: string): Promise<void>;
    updateLocale(userId: string, locale: string): Promise<void>;
    updateScriptPreference(userId: string, scriptPreference: string): Promise<UpdatedScriptPreference>;
}

export class DefaultAccountService implements AccountService {
    readonly #userServiceClient: UserServiceClient;

    constructor(userServiceClient: UserServiceClient) {
        this.#userServiceClient = userServiceClient;
    }

    public async deleteAccount(userId: string): Promise<void> {
        const response = await this.#userServiceClient.requestDeleteAccount({userId});
        const errors = response.errors;
        if (errors != null && errors.length > 0) {
            throw new ReasonError(errors[0].code, errors[0].message);
        }
    }

    public async updateLocale(userId: string, locale: string): Promise<void> {
        const response = await this.#userServiceClient.requestUpdateUserLocale({userId, locale});
        const errors = response.errors;
        if (errors != null && errors.length > 0) {
            throw new ReasonError(errors[0].code, errors[0].message);
        }
    }

    public async updateScriptPreference(userId: string, scriptPreference: string): Promise<UpdatedScriptPreference> {
        const response = await this.#userServiceClient.requestUpdateUserScriptPreference({userId, scriptPreference});
        const errors = response.errors;
        if (errors != null && errors.length > 0) {
            throw new ReasonError(errors[0].code, errors[0].message);
        }
        return {
            scriptPreference: response.user?.scriptPreference ?? scriptPreference,
            pendingDecision: response.user?.pendingDecision ?? null,
        };
    }
}
